import React, { memo, forwardRef } from 'react';
import { isEqual } from 'lodash';
import { SortableElement } from 'react-sortable-hoc';
import Cell from './Cell';
import { RowWrapper, ActionColumn } from './styles';

const Row = (
  {
    rowIdx,
    row,
    viewportColumns,
    top,
    rowStyle,
    CellRenderer,
    onRowClick,
    toggleRow,
    actionRenderer,
    gridRef,
    reorder,
    isSticky,
    isExpended,
    gridApi
  },
  ref
) => (
  <RowWrapper
    ref={ref}
    row={row}
    isSticky={isSticky}
    className={rowStyle?.(row)}
    {...(reorder ? { $top: top } : { style: { top } })}>
    {viewportColumns.map((column, index) => (
      <Cell
        key={`${column.dataKey}-${index}`}
        rowIdx={rowIdx}
        column={column}
        row={row}
        CellRenderer={CellRenderer}
        onRowClick={onRowClick}
        toggleRow={toggleRow}
        isExpended={isExpended}
        gridApi={gridApi}
      />
    ))}

    {actionRenderer && <ActionColumn>{actionRenderer({ rowData: row, gridRef })}</ActionColumn>}
  </RowWrapper>
);

// const deepComparison = (rowA, rowB) => {
//   const { viewportColumns: viewportColumnsA, ...filteredObjectA } = rowA;
//   const { viewportColumns: viewportColumnsB, ...filteredObjectB } = rowB;
//   const result = isEqual(filteredObjectA, filteredObjectB) && isEqual(viewportColumnsA, viewportColumnsB);

//   return isEqual(rowA, rowB);
// };

export default memo(SortableElement(forwardRef(Row)), isEqual);
